export const DATE_FORMATS = {
    only_date: "DD. MM. YYYY"
}
